import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { FloatingChatLauncher } from "@/components/chat/FloatingChatLauncher";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");

// /questions/* is served as fully prerendered static HTML (see
// frontend/scripts/prerender-routes.js). On those production pages the
// #root element carries an explicit marker and is already populated with
// the page's article/nav/etc., so booting React would wipe static content.
// Generic SPA fallbacks have no marker and mount the responsive fallback.
const isPrerenderedStaticPage =
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/questions") &&
  rootEl?.dataset.prerenderedQuestions === "true";

if (isPrerenderedStaticPage) {
  const chatRootEl = document.createElement("div");
  chatRootEl.id = "supple-static-chat-root";
  document.body.appendChild(chatRootEl);
  ReactDOM.createRoot(chatRootEl).render(
    <React.StrictMode>
      <BrowserRouter><FloatingChatLauncher /></BrowserRouter>
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
